import { AppSettingsAdapter } from '@agilox/common';
import { AppSettings } from '../../interfaces/app-settings.interface';
import { DateSelector } from '../services/appsettings/date-selector.interface';
import { Granularity } from '../services/appsettings/granularity.enum';
import { Mode } from '../services/appsettings/mode.enum';
import { TimeframePresets } from '../../enums/timeframe.presets';
import { SHIFT_END_18_MS, SHIFT_START_8_MS, WORKING_DAYS } from '../../constants/date-filter.const';

const defaultDateSelect = () => {
	const today = new Date();
	const priorDate = new Date().setDate(today.getDate() - 7);

	return {
		startDate: new Date(priorDate).getTime(),
		endDate: today.getTime(),
		granularity: Granularity.hh,
		combined: false,
		shiftOn: false,
		shiftStart: SHIFT_START_8_MS,
		shiftEnd: SHIFT_END_18_MS,
		shiftDays: WORKING_DAYS,
		excludeDates: [],
		timeframe: TimeframePresets.Last7Days,
		mode: Mode.each,
	};
};

export class AnalyticsAppSettingsAdapter implements AppSettingsAdapter<AppSettings> {
	defaults(id: string): AppSettings {
		const dateSelector: DateSelector = defaultDateSelect();
		return {
			id,
			dateSelector,
			selectedMachines: [],
			machineToShow: '',
			onboarding: {
				analyticsWatched: false,
			},
			indicatorWidgets: [],
			userGeneratedWidgets: [],
			isWidgetMigrationComplete: false,
			boards: [],
		};
	}

	parse(id: string, raw: unknown): AppSettings {
		const settings = raw as any;
		return {
			id,
			dateSelector: settings?.dateSelector ?? defaultDateSelect(),
			selectedMachines: settings?.selectedMachines ?? [],
			machineToShow: settings?.machineToShow ?? '',
			onboarding: {
				analyticsWatched: settings?.onboarding?.analyticsWatched ?? false,
			},
			indicatorWidgets: settings?.indicatorWidgets ?? [],
			userGeneratedWidgets: settings?.userGeneratedWidgets ?? [],
			isWidgetMigrationComplete: settings.isWidgetMigrationComplete ?? false,
			boards: settings.boards ?? [],
		};
	}

	toPayload(settings: AppSettings): unknown {
		return settings;
	}
}
